module.exports = __webpack_public_path__ + "static/img/qrcode.960a700.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/qrcode.png
// module id = Nm7F
// module chunks = 1